import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";

export default function OneService({ order, text = {} }) {
	const appContext = useContext(AppContext);
	const [ready, setReady] = useState(false);

	useEffect(() => {
		setReady(true);
	}, []);

	return (
		<div 
			className="pb-5"
			data-aos="fade-right"
		>
			<div
				className="text-center mt-3"
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					gap: "10px",         // allows natural mobile wrapping
				}}
			>

				{/* CIRCLE – never shrink */}
				<div
					style={{
						width: "90px",
						height: "90px",
						borderRadius: "50%",
						background: "linear-gradient(135deg, #e2c000ff 0%, #d17000ff 40%, #047591ff 100%)",
						display: "grid",
						placeItems: "center",
						flexShrink: 0,            // prevents shrinking
					}}
				>
					<h1 
						className="font-bold text-primary"
						style={{
						width: "70px",
						height: "70px",
						borderRadius: "50%",
						background: "white",
						display: "grid",
						placeItems: "center",    // prevents shrinking
					}}
					>
						{order}
					</h1>
				</div>

				{/* TEXT BOX – allowed to shrink safely */}
				<div
					style={{
						flexGrow: 1,
						flexShrink: 1,           // shrinkable
						minWidth: "160px",       // never collapses too far
						maxWidth: "350px",       // keeps desktop look
						minHeight: "75px",
						borderRadius: "30px",
						background: "linear-gradient(135deg, #e2c000ff 0%, #d17000ff 40%, #2811f3ff 100%)",
						display: "grid",
						placeItems: "center",
						padding: "10px 20px",
					}}
				>
					<h6 className="text-light font-semi-bold text-start">{text}</h6>
				</div>

			</div>
		</div>
	);
}
